import { ECountry } from '@/shared/enum/country.enum'

/**
 * A map of production urls to their corresponding link.
 * @type {Map<ECountry, string>}
 */
export const mpcProductionUrls: Map<ECountry, string> = new Map([
  [ECountry.GT, 'https://gt.mipagoclaro.com'],
  [ECountry.CR, 'https://cr.mipagoclaro.com'],
  [ECountry.HN, 'https://hn.mipagoclaro.com'],
  [ECountry.NI, 'https://ni.mipagoclaro.com'],
  [ECountry.SV, 'https://sv.mipagoclaro.com']
])

/**
 * A map of stage urls to their corresponding link.
 * @type {Map<ECountry, string>}
 */
export const mpcStageUrls: Map<ECountry, string> = new Map([
  [ECountry.GT, 'https://invoices-gt.portal-universal.com'],
  [ECountry.CR, 'https://invoices-cr.portal-universal.com'],
  [ECountry.HN, 'https://invoices-hn.portal-universal.com'],
  [ECountry.NI, 'https://invoices-ni.portal-universal.com'],
  [ECountry.SV, 'https://invoices-sv.portal-universal.com']
])
